import { apiClientV1 } from './apiClient';

export default {
  getSharedVideo: (videoId, params) => apiClientV1.get(`/video/shared/${videoId}`, { params, silentErrorNotification: true }),
  logRecipientWatched: (recipientId, params) => apiClientV1.get(`/video/${recipientId}/watched`, { params }),
  getVideoSegmentsByClips: (videoId) => apiClientV1.get(`/video/${videoId}/segments-by-clips`),
  getVideoSegments: (videoId) => apiClientV1.get(`/video/${videoId}/segments`),

  // Shared playlist
  getSharedPlaylist: (playlistId, recipientId) => apiClientV1.get(`/video/playlists/${playlistId}/recipient/${recipientId}`, { silentErrorNotification: true }),
  logRecipientWatchedPlaylistVideo: ({ playlistId, ...rest }) => apiClientV1.post(`/video/playlist/${playlistId}/watch`, { ...rest }, { silentErrorNotification: true }),

  // Engrain (SightMap) event tracking
  logVideoCalculatorEvent: ({ videoId, ...params }) => apiClientV1.post(`/video/${videoId}/calculator/events`, { ...params })
};
